/* 
Object:         Inputs
Description:    Logic for inputs who are 
Used in:        Forms or pages where html inputs are available.
*/

// declare var dialog: any;

import * as dialog from "./dialog"

let titleDialogUnSavedChanges = "Unsaved changes";
let contentDialogUnSavedChanges = "Continue while having unsaved changes";


/**
 * Navigate to a specific url (used in all modules to navigate -> edit)
 * @param {string} title
 * @param {string} content
 */
export function initialize(title: string, content: string): void {
    titleDialogUnSavedChanges = title;
    contentDialogUnSavedChanges = content;

    // Select all different inputs
    const inputs = $('form :input, select, :checkbox');
    // const forms = $('form');

    // Inputs foreach 
    inputs.each(function () {
        let valueDataValReq = $(this).attr("data-val-required");    // Get the data value required 
        let valueType = $(this).attr("type");                       // Get the type

        if (valueType == "checkbox") {
            if (($(this)[0] as any).disabled && ($(this)[0] as any).checked) {
                // set same value to hidden field: <input name="Enable" type="hidden" value="false" >
                let cbName = ($(this)[0] as any).name;
                let cbValue = ($(this)[0] as any).checked;
                $('form :input:hidden[name="' + cbName + '"]').val(cbValue);
            }
        }

        // The dataValueRequered attribute must not be undefined and the input is not hidden (for id's that are send with the post request).
        if (valueDataValReq !== undefined && valueType !== "hidden" && valueType !== "checkbox") {
            var parentElement = $(this).parent();
            parentElement.addClass("precom-requiredInput");
        }

        // This is general for all the text inputs. 
        $(this).on('input', function () {

            const parentElement = $(this).parent();

            if ((this as any).defaultValue !== (this as any).value) {
                parentElement.addClass("precom-dirtyInput");
            } else {
                parentElement.removeClass("precom-dirtyInput");
            }
        });

        // This is specific for all the combobox/listbox inputs  
        $(this).on('change', function () {

            const parentElement = $(this).parent();

            if ((this as any).defaultValue !== (this as any).value) {
                parentElement.addClass("precom-dirtyInput");
            } else {
                parentElement.removeClass("precom-dirtyInput");
            }
        });
    });
}

/**
 * Navigate to a specific url (used in all modules to navigate -> edit)
 */
export function removeDirtyInput(): void {
    $('*').removeClass('precom-dirtyInput'); // remove all the precom-dirty inputs ... 
}

/**
 * Navigate to a specific url (used in all modules to navigate -> edit)
 * @param {Event | null} event
 * @param {() => void} yesActionCallback
 */
export function checkDirtyInput(event: any | null, yesActionCallback: () => void): void {
    if ($('.precom-dirtyInput [id!="Loginname"][type!=password]').length) {
        if (event != null) {
            event.preventDefault();
        }
        dialog.createDialogWithCustomTitleAndMessage(titleDialogUnSavedChanges, contentDialogUnSavedChanges, yesActionCallback, function () { });
    } else {
        yesActionCallback(); // When there are no changes, call the callback instantaniously
    }
}
